<template>
  <div class="footer">
    <div class="footer-body">
      <div class="footer-left">
        <div class="left-entry">
          <h4>关于我们</h4>
          <ul>
            <li @click="this.$router.push('/About')"><a href="#">关于我们</a></li>
            <li @click="this.$router.push('/Contact')"><a href="#">联系我们</a></li>
            <li @click="this.$router.push('/Agent')"><a href="#">公司代理</a></li>
            
          </ul>
        </div>
        <div class="left-entry">
          <h4>资讯列表</h4>
          <ul>
            <li @click="this.$router.push('/News/0')"><a href="#">最新公告</a></li>
            <li @click="this.$router.push('/News/1')"><a href="#">新闻动态</a></li>
          </ul>
        </div>
        <div class="left-entry">
          <h4>钱币鉴定</h4>
          <ul>
            <li @click="this.$router.push('/Appreciation')"><a href="#">钱币赏析</a></li>
            <li @click="this.$router.push('/Charge')"><a href="#">我要送评</a></li>
          </ul>
        </div>

        <div class="left-entry">
          <h4>主营业务</h4>
          <ul>
            <li @click="this.$router.push('/Appreciation')"><a href="#">收藏品</a></li>
            <li @click="this.$router.push('/Standard')"><a href="#">评级</a></li>
          </ul>
        </div>
      </div>

      <div class="footer-right">
        <div class="right-entry">
          <ul>
            <li>
              <div class="icon-div"><el-icon class="icon-right"><PhoneFilled/></el-icon></div>
              <p>公司热线：178 3784 4475</p>
            </li>
            <li>
              <div class="icon-div"><el-icon class="icon-right"><Comment/></el-icon></div>
              <p>邮&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;箱：zhengquanpingji@163.com</p>
            </li>
            <li>
              <div class="icon-div"><el-icon class="icon-right"><HomeFilled/></el-icon></div>
              <p>地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址：河南省开封市鼓楼区古玩大市场政泉评级</p>
            </li>
          </ul>
          
        </div>
        
        <div class="right-qr">
          <div>
            <img src="../../assets/img/zqpjlink/gongzhonghao.png" alt="">
            <h5>企业二维码</h5>
          </div>
         <!-- <div>
            <img src="../../assets/img/Header/logo.png" alt="">
            <h5>企业公众号</h5>
          </div> -->
        </div>
      </div>
    </div>
	<br>
	<div><a href="https://beian.miit.gov.cn/" style="color: #e2e2e2;text-decoration: none;">Copyright 政泉评级 All Rights Reserved &nbsp; 豫ICP备2022005665号-1</a></div>
  </div>
</template>

<script>
import { PhoneFilled, HomeFilled, Comment } from '@element-plus/icons'
export default {
  name: 'Footer',
  components: {
    PhoneFilled,
    HomeFilled,
    Comment
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

  .footer {
    background: #606266;
    width: 100%;
    margin-top: 80px;
    color: #e2e2e2;
    
    .footer-body {
      width: 1600px;
      margin: 0 auto;
      display: flex;
      @media only screen and (max-width: 1650px) {
        width: 100%;
      }
      @media only screen and (max-width: 1550px) {
        display: block;
      }
      
    }
    .footer-left {
      width: 50%;
      display: flex;
      @media only screen and (max-width: 1550px) {
        width: 100%;
      }
      @media only screen and (max-width: 665px) {
        display: flex;
        flex-wrap: wrap;
      }

      .left-entry:first-child {
        border-left: 0;
        margin-left: 130px;
        @media only screen and (max-width: 1550px) {
          margin-left: 23%;
        }
        @media only screen and (max-width: 1030px) {
          margin-left: 15%;
        }
        @media only screen and (max-width: 790px) {
          margin-left: 50px;
        }
        @media only screen and (max-width: 750px) {
          margin-left: 30px;
        }
        @media only screen and (max-width: 351px) {
          margin-left: 10px;
        }
      }
      .left-entry:nth-child(2) {
        @media only screen and (max-width: 351px) {
          margin-left: 10px;
          margin-right: 0px;
        }
      }
      .left-entry:nth-child(3) {
        @media only screen and (max-width: 665px) {
          margin-left: 30px;
          margin-right: 30px;
        }
        @media only screen and (max-width: 507px) {
          border: 0;
        }
        @media only screen and (max-width: 491px) {
          margin-left: 30px;
          margin-right: 30px;
          
        }
        @media only screen and (max-width: 351px) {
          margin-left: 10px;
          margin-right: 0px;
        }
        
      }
      .left-entry:nth-child(4) {
        @media only screen and (max-width: 665px) {
          margin-left: 30px;
          margin-right: 20px;
        }
        @media only screen and (max-width: 511px) {
          margin-left: 10px;
        }
        @media only screen and (max-width: 351px) {
          margin-left: 10px;
        }
      }
      .left-entry {
        
        margin: 30px 0 0 40px;
        padding: 0 20px;
        border-left: 1px solid #909399;
        
        h4 {
          font-size: 20px;
          font-weight: 300;
        }
        ul {
          
          margin-top: 20px;
          li {
            list-style: none;
            line-height: 30px;
            position: relative;
            &:before {
              content: '';
              position: absolute;
              bottom: 0;
              left: 10px;
              width: 75%;
              height: 2px;
              background: #e22434;
              transform: scaleX(0);
              transform-origin: 50%;
              transition: .5s;
            }
            &:hover:before {
              transform: scaleX(1);
            }
            &:hover {
              a {
                color: #e22434;
              }
            }
            a{
              color: #e2e2e2;
              font-size: 14px;
              text-decoration: none;
              transition: .5s;
            }
          }
        }
      }
      
    }
    .footer-right {
      width: 50%;
      display: flex;
      @media only screen and (max-width: 1550px) {
        width: 100%;
      }
      @media only screen and (max-width: 830px) {
        display: block;
      }
      
      .right-entry {
        width: 55%;
        
        @media only screen and (max-width: 790px) {
          width: 200px;
        }
        @media only screen and (max-width: 1550px) {
          width: 35%;
          margin-left: 15%;
        }
        @media only screen and (max-width: 1217px) {
          width: 420px;
        }
        @media only screen and (max-width: 1030px) {
          margin-left: 5%;
        }
        @media only screen and (max-width: 830px) {
          width: 90%;
          margin: 0 auto;
        }
        @media only screen and (max-width: 490px) {
          font-size: 14px;
        }
        
        ul {
          
          li {
            list-style: none;
            display: flex;
            cursor: default;
            margin-top: 12px;
            &:nth-child(1) {
              margin-top: 40px;
            }
            .icon-div {
              margin-top: 3px;
              margin-right: 12px;
              .icon-right {
                font-size: 18px;
                @media only screen and (max-width: 490px) {
                  font-size: 15px;
                }
              }
            }
          }
        }
        // p {
        //   text-align: left;
        //   margin-top: 30px;
        //   a {
        //     margin-top: 10px;
        //   }
        // }
      }
      .right-qr {
		margin-left: 100px;
        display: flex;
        margin-top: 20px;
        @media only screen and (max-width: 1550px) {
          width: 35%;
          margin: 0 auto;
        }
        @media only screen and (max-width: 830px) {
          width: 65%;
          margin: 0 auto;
          padding-left: 30%;
        }
        @media only screen and (max-width: 630px) {
			margin-left: 100px;
          width: 65%;
          margin: 0 auto;
          padding-left: 20%;
        }
        
        @media only screen and (max-width: 440px) {
			margin-left: 35%;
          width: 85%;
          padding-left: 10%;
        }
        @media only screen and (max-width: 430px) {
          padding-left: 0;
        }
        @media only screen and (max-width: 370px) {
          width: 85%;
        }
        img {
          width: 127px;
          &:nth-child(1) {
          }
        }

        h5 {
          cursor: default;
        }
        
      }
    }

  }
</style>
